export default {
      id: "nuit-avec-averses-de-neige-faible-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#nuit-avec-averses-de-neige-faible-usage",
      toString: function () {
        return this.url;
      }
    }